const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = function saveBookmark(user, id, type, bookmarked, authContext) {
	const [
		{ isAuthenticated },
		{ dispatch, logout, checkAuth, isLoggedIn },
		[userData, setUserData],
	] = authContext;
	let bookmarks = user.relationships?.field_bookmarks?.data || [];
	if (!bookmarked) {
		bookmarks = [
			...bookmarks,
			{
				type,
				id,
			},
		];
	} else {
		bookmarks = [...bookmarks.filter((item) => item.id != id)];
	}
	let data = {
		type: "user--user",
		id: user.id,
		relationships: { field_bookmarks: { data: [...bookmarks] } },
	};
	return fetchAuthenticatedContent({
		endpoint: `user/user/${user.id}`,
		method: "PATCH",
		body: {
			data,
		},
		dispatch,
	});
};
